import { defineMessages } from 'react-intl';

export const tailorFormsTranslations = defineMessages({
  bbTailroingFormTitleExclude: {
    id: 'tailoring.bbTailroingFormTitleExclude',
    defaultMessage: 'Exclude Building Block',
    description: 'Exclude building block title',
  },
  bbTailroingFormTitleInclude: {
    id: 'tailoring.bbTailroingFormTitleInclude',
    defaultMessage: 'Include Building Block',
    description: 'Include building block title',
  },
  bbTailoringFormExclusionExplanationLabel: {
    id: 'tailoring.bbTailroingFormExclusionExplanationLabel',
    defaultMessage: 'Reason for exclusion',
    description: 'Exclusion explanation label',
  },
  bbTailoringFormInclusionExplanationLabel: {
    id: 'tailoring.bbTailroingFormInclusionExplanationLabel',
    defaultMessage: 'Reason for inclusion',
    description: 'Inclusion explanation label',
  },
  bbTailoringFormInclusionExplanationPlaceholder: {
    id: 'tailoring.bbTailroingFormInclusionExplanationPlaceholder',
    defaultMessage: 'Explain why this Building Block is included',
    description: 'Inclusion explanation placeholder',
  },
  bbTailoringFormExclusionExplanationPlaceholder: {
    id: 'tailoring.bbTailroingFormExclusionExplanationPlaceholder',
    defaultMessage: 'Explain why this Building Block is excluded',
    description: 'Exclusion explanation placeholder',
  },
  bbTailoringFormReevaluationLabel: {
    id: 'tailoring.bbTailroingFormReevaluationLabel',
    defaultMessage: 'Needs to be reevaluated during development',
    description: 'Reevaluation label',
  },
  bbTailoringFormInclusionSubmitButton: {
    id: 'tailoring.bbTailroingFormInclusionSubmitButton',
    defaultMessage: 'Include',
    description: 'Include button',
  },
  bbTailoringFormExclusionSubmitButton: {
    id: 'tailoring.bbTailroingFormExclusionSubmitButton',
    defaultMessage: 'Exclude',
    description: 'Exclude button',
  },
  bbTailoringFormCancelButton: {
    id: 'tailoring.bbTailoringFormCancelButton',
    defaultMessage: 'Cancel',
    description: 'Cancel button',
  },
  doTailoringFormExclusionExplanationPlaceholder: {
    id: 'tailoring.doTailoringFormExclusionExplanationPlaceholder',
    defaultMessage: 'Explain why this Design Obligation is excluded',
    description: 'Exclusion explanation placeholder',
  },
  doTailoringFormInclusionExplanationPlaceholder: {
    id: 'tailoring.doTailoringFormInclusionExplanationPlaceholder',
    defaultMessage: 'Explain why this Design Obligation is included',
    description: 'Inclusion explanation placeholder',
  },
  doTailoringFormBBSubtitleExcluded: {
    id: 'tailoring.doTailoringFormBBSubtitleExcluded',
    defaultMessage: 'Following Building Blocks will be excluded:',
    description: 'Building Block subtitle',
  },
  doTailoringFormBBSubtitleIncluded: {
    id: 'tailoring.doTailoringFormBBSubtitleIncluded',
    defaultMessage: 'Following Building Blocks will be included:',
    description: 'Building Block subtitle',
  },
  doTailoringFormExclusionSubmitButton: {
    id: 'tailoring.doTailoringFormExclusionSubmitButton',
    defaultMessage: 'Exclude selected',
    description: 'Exclude button',
  },
  doTailoringFormInclusionSubmitButton: {
    id: 'tailoring.doTailoringFormInclusionSubmitButton',
    defaultMessage: 'Include selected',
    description: 'Include button',
  },
});
